import React, { useEffect, useRef } from 'react';

const ClienteleSection = () => {
  const trackRef = useRef(null);

  const logos = [
    '/client1.jpg',
    '/client2.jpg',
    '/client3.jpg',
    '/client4.jpg',
    '/client5.jpg',
    '/client6.jpg',
    '/client7.jpg'
  ];

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    // Clone logos for infinite scroll effect
    const clone = track.cloneNode(true);
    track.parentElement.appendChild(clone);

    return () => {
      if (clone && clone.parentElement) {
        clone.parentElement.removeChild(clone);
      }
    };
  }, []);

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-bold text-2xl md:text-3xl mb-8 text-gray-900">
          You Can Be The <span className="text-red-600">Face Of</span>
        </h2>

        <div className="overflow-hidden relative mt-8 py-4">
          <div className="flex animate-scroll" ref={trackRef}>
            {logos.map((logo, index) => (
              <div key={index} className="flex-shrink-0 px-6 md:px-8">
                <img
                  src={logo}
                  alt={`Client ${index + 1}`}
                  className="h-12 md:h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClienteleSection;